import Modal from '@app/components/Modal/Modal'
import * as ModalLayout from '@app/components/Modal/styled'
import React, { useState } from 'react'

import * as S from './CopyTeeConfirmationModal.styles'

interface CopyTeeConfirmationModalProps {
  showModal: boolean
  closeModal: () => void
  acceptCurrentHoleFunction: (resetSource: boolean) => void
  acceptAllUnlockedHolesFunction: (resetSource: boolean) => void
  targetTeeNumber: number
  targetTeeName: string
}

export const CopyTeeConfirmationModal = ({
  showModal,
  closeModal,
  acceptCurrentHoleFunction,
  acceptAllUnlockedHolesFunction,
  targetTeeNumber,
  targetTeeName,
}: CopyTeeConfirmationModalProps) => {
  const [resetSource, setResetSource] = useState(false)

  return (
    <Modal
      isOpen={showModal}
      onClose={closeModal}
      width="720px"
      closeOnBackdropClick={true}
      showCloseButton={true}
    >
      <S.Header>
        <S.Title>
          Copy adjustments to Tee {targetTeeNumber} ({targetTeeName})?
        </S.Title>
        <S.Subtitle>
          This will replace all existing adjustments on the target tee with values
          from the current tee.
        </S.Subtitle>
        <S.TeePill>Target: Tee {targetTeeNumber} ({targetTeeName})</S.TeePill>
      </S.Header>

      <ModalLayout.ModalScrollContent>
        <S.Body>
          <S.ResetSourceRow>
            <S.ResetSourceCheckbox
              type="checkbox"
              checked={resetSource}
              onChange={(e) => setResetSource(e.target.checked)}
            />
            <S.ResetSourceLabel>
              Clear adjustments on source tee after copying
            </S.ResetSourceLabel>
          </S.ResetSourceRow>

          <S.OptionGrid>
            <S.OptionCard>
              <S.OptionTitle>Copy current hole</S.OptionTitle>
              <S.OptionText>
                Use this when you only want to update the currently selected hole.
              </S.OptionText>
              <S.OptionButton
                $variant="secondary"
                onClick={() => acceptCurrentHoleFunction(resetSource)}
              >
                Copy current hole
              </S.OptionButton>
            </S.OptionCard>

            <S.OptionCard>
              <S.OptionTitle>Copy all unlocked holes</S.OptionTitle>
              <S.OptionText>
                Apply to every unlocked hole. Locked holes are skipped automatically.
              </S.OptionText>
              <S.OptionButton
                $variant="primary"
                onClick={() => acceptAllUnlockedHolesFunction(resetSource)}
              >
                Copy all unlocked holes
              </S.OptionButton>
            </S.OptionCard>
          </S.OptionGrid>
        </S.Body>
      </ModalLayout.ModalScrollContent>

      <ModalLayout.ModalFooter>
        <S.CancelButton onClick={closeModal}>Cancel</S.CancelButton>
      </ModalLayout.ModalFooter>
    </Modal>
  )
}
